import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick } from '@olympeio/core';
import React from 'react';
import { Paper, IconButton, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default class WBSAdvancedSearchBar extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {React.ReactElement}
     */

    static getReactComponent($) {
        return (props) => {
            return (
                <Paper
                    component="form"
                    sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        width: '70%',
                        backgroundColor: 'rgb(250,250,250)',
                        cursor: 'pointer !important',
                    }}
                >
                    <IconButton
                        className={'base-popup-button'}
                        aria-label="search"
                        onClick={() => {
                            $.trigger('Trigger WBS Popup');
                        }}
                    >
                        <Typography>Advanced search</Typography>
                        <SearchIcon />
                    </IconButton>
                </Paper>
            );
        };
    }
}

registerBrick('018017c37cf95e1e2aaa', WBSAdvancedSearchBar);
